// ABOUTME: Document-level click listener recording clicks on elements marked with data-analytics.
// ABOUTME: Listens in the capture phase so stopped propagation and navigating clicks are still seen.

import { useEffect } from 'react';

import { readAnalyticsTarget } from '../capture/readAnalyticsTarget';
import { trackAction } from '../capture/trackAction';

export function useActionTracking() {
    useEffect(() => {
        // Capture phase: seen even when a handler stops propagation, and before the click navigates.
        const handler = (event: MouseEvent) => {
            try {
                const target = readAnalyticsTarget(event.target);
                if (target) trackAction(target.name, target.properties);
            } catch {
                // Capture never throws into the app.
            }
        };
        document.addEventListener('click', handler, { capture: true });
        return () => document.removeEventListener('click', handler, { capture: true });
    }, []);
}
